module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-md-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Settings",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholder": "Username",
      "prefixAddonText": "@"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "suffixAddonText": ".00"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "prefixAddonText": "$",
      "suffixAddonText": ".00"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholder": "Email",
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "slot": "slotPrefixAddonText"
    },
    slot: "slotPrefixAddonText"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "slot": "slotSuffixAddonText"
    },
    slot: "slotSuffixAddonText"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar",
    attrs: {
      "slot": "slotPrefixAddonText"
    },
    slot: "slotPrefixAddonText"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ambulance",
    attrs: {
      "slot": "slotSuffixAddonText"
    },
    slot: "slotSuffixAddonText"
  })]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "align": "right",
      "name": "Save"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4428c2f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsAdmin.vue
// module id = 702
// module chunks = 0